import React from 'react'

import css from './style.scss'

const SkipLink = () => (
  <a href='#main-content' className={css.skipLink}>Skip to main content</a>
)

export default SkipLink
